import AppleSignInButton from 'react-apple-signin-auth';
import KakaoLogin from "react-kakao-login";
import kakaoIcon from '../../assets/images/social_kakao.png';
import googleIcon from '../../assets/images/social_google.png';
import appleIcon from '../../assets/images/social_apple.png';
import { useRecoilState } from 'recoil';
import { evWhereMemberState, isEvWhereMemberState, requiredDataState } from '../../recoil/atoms';
import { useEffect, useState } from 'react';
import { divide } from 'lodash';
import { signInWithPopup, OAuthProvider, GoogleAuthProvider } from "firebase/auth";
import { auth } from '../../firbaseConfig';
import { parseJwt } from '../../util';
/** Apple Signin button */
const AppleButton = () => {
    const [requiredData, setRequiredData] = useRecoilState(requiredDataState);
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [isEvWhereMember, setIsEvWhereMember] = useRecoilState(isEvWhereMemberState);
    const handleAppleLogin = async () => {
        try {
            const provider = new OAuthProvider('apple.com');
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const appleToken = (result as any)._tokenResponse?.oauthIdToken;
            const base64Url = appleToken.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
            const decodedToken = JSON.parse(jsonPayload);
            const sub = decodedToken.sub;
            setEvWhereMember({
                ssbyp: 'apple',
                lgn_Id: user.email || undefined,
                lgnPassword: await sub,
                idToken: await sub,
            });
            setIsEvWhereMember(true);
        } catch (error) {
            console.error('Apple 로그인 실패:', error);
        }
    };

    return (
        <button onClick={handleAppleLogin}><img src={appleIcon} alt="애플 로그인" /></button>
    )
}

const GoogleButton = () => {
    const [requiredData, setRequiredData] = useRecoilState(requiredDataState);
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [isEvWhereMember, setIsEvWhereMember] = useRecoilState(isEvWhereMemberState);
    const handleGoogleLogin = async () => {
        try {
            const provider = new GoogleAuthProvider();
            provider.setCustomParameters({
                prompt: 'select_account',
            });
            const result = await signInWithPopup(auth, provider);
            var token = await result.user.getIdToken();

            // JWT 토큰 디코딩
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            const decodedToken = JSON.parse(jsonPayload);
            const sub = decodedToken.sub;
            const user = result.user;
            setEvWhereMember({
                ssbyp: 'google',
                lgn_Id: user.email || '',
                lgnPassword: await sub,
                idToken: await sub,
            });
            setIsEvWhereMember(true);
        } catch (error) {
            console.error('Google 로그인 실패:', error);
        }
    };
    return (
        <button onClick={handleGoogleLogin}><img src={googleIcon} alt="구글 로그인" /></button>
    )
}

declare global {
    interface Window {
        Kakao: {
            init: (key: string) => void;
            isInitialized: () => boolean;
            Auth: {
                login: (params: any) => void;
                logout: (callback: () => void) => void;
                getAccessToken: () => string | null;
            };
        };
    }
}

const SocialKakao = () => {
    const kakaoClientId = '7bf1c7d17c2e4b703a45ba8a1bb136a2'
    const redirectUri = `${process.env.REACT_APP_KAKAO_REDIRECT_HOST}/social/kakao`;

    const handleKakaoLogin = () => {
        const scope = 'account_email';
        const prompt = 'select_account';

        const kakaoAuthUrl = `https://kauth.kakao.com/oauth/authorize?client_id=${kakaoClientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&prompt=${prompt}`;

        // 팝업 창 크기 설정
        const width = 500;
        const height = 600;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);

        // 팝업 창 옵션
        const popupOptions = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,status=yes,resizable=yes`;

        // 팝업 창 열기
        const popup = window.open(kakaoAuthUrl, 'kakaoLogin', popupOptions);

        // 팝업 창이 닫혔을 때 처리
        if (popup) {
            const checkPopup = setInterval(() => {
                if (popup.closed) {
                    clearInterval(checkPopup);
                    // console.log('팝업이 닫혔습니다');
                }
            }, 1000);
        }
    };

    return (
        <button
            onClick={handleKakaoLogin}
            style={{ width: "46px", height: "46px", boxSizing: "border-box", borderRadius: "50%" }}
        >
            <img src={kakaoIcon} alt="카카오 로그인" />
        </button>
    );
};


export { AppleButton, SocialKakao, GoogleButton };